'use strict';

const init = () => {
    const footerNavigation = document.querySelector('.tc-website-footernavigation');
    const uri = window.location.pathname

    footerNavigation.querySelectorAll('a').forEach(link => {
        if (link.getAttribute('href') === uri) {
            link.parentElement.classList.add('current')
            link.parentElement.classList.remove('normal')
        }
    })
}

export default {init}
